// Auto-generated comprehensive metafield options - 2026-03-31T20:07:53.650Z
// This file includes metafield definitions + sampled unstructured metafields
// Generated by scripts/fetch-all-metafields-optimized.js
// Note: With 257k+ products, we sample strategically to capture all metafield variations

export const SHOPIFY_FIELD_OPTIONS = [
  {
    "label": "— Order Fields —",
    "value": "__group_order",
    "disabled": true
  },
  {
    "label": "Order Number",
    "value": "order.orderNumber"
  },
  {
    "label": "Order ID (Shopify)",
    "value": "order.orderId"
  },
  {
    "label": "Order Date",
    "value": "order.createdDate"
  },
  {
    "label": "Financial Status",
    "value": "order.financialStatus"
  },
  {
    "label": "Fulfillment Status",
    "value": "order.fulfillmentStatus"
  },
  {
    "label": "Currency",
    "value": "order.currency"
  },
  {
    "label": "Shipping Method",
    "value": "order.shippingMethod"
  },
  {
    "label": "Shipping Cost (Original)",
    "value": "order.shippingPrice"
  },
  {
    "label": "Shipping Cost (Final)",
    "value": "order.shippingCost"
  },
  {
    "label": "Shipping Cost (Discounted)",
    "value": "order.shippingDiscountedPrice"
  },
  {
    "label": "Customer PO / Note (cust_po)",
    "value": "order.customerNote"
  },
  {
    "label": "Tracking / Ship Number",
    "value": "order.trackingNumber"
  },
  {
    "label": "— Billing Address —",
    "value": "__group_billing",
    "disabled": true
  },
  {
    "label": "Billing Name",
    "value": "billing.name"
  },
  {
    "label": "Billing First Name",
    "value": "billing.firstName"
  },
  {
    "label": "Billing Last Name",
    "value": "billing.lastName"
  },
  {
    "label": "Billing Company",
    "value": "billing.company"
  },
  {
    "label": "Billing Phone",
    "value": "billing.phone"
  },
  {
    "label": "Billing Address 1",
    "value": "billing.address1"
  },
  {
    "label": "Billing Address 2",
    "value": "billing.address2"
  },
  {
    "label": "Billing City",
    "value": "billing.city"
  },
  {
    "label": "Billing State / Province",
    "value": "billing.province"
  },
  {
    "label": "Billing Province Code",
    "value": "billing.provinceCode"
  },
  {
    "label": "Billing Zip / Postal Code",
    "value": "billing.zip"
  },
  {
    "label": "Billing Country",
    "value": "billing.country"
  },
  {
    "label": "Billing Country Code",
    "value": "billing.countryCode"
  },
  {
    "label": "Billing Latitude",
    "value": "billing.latitude"
  },
  {
    "label": "Billing Longitude",
    "value": "billing.longitude"
  },
  {
    "label": "— Shipping Address —",
    "value": "__group_shipping",
    "disabled": true
  },
  {
    "label": "Shipping Name",
    "value": "shipping.name"
  },
  {
    "label": "Shipping Company",
    "value": "shipping.company"
  },
  {
    "label": "Shipping Phone",
    "value": "shipping.phone"
  },
  {
    "label": "Shipping Address",
    "value": "shipping.address1"
  },
  {
    "label": "Shipping City",
    "value": "shipping.city"
  },
  {
    "label": "Shipping State / Province",
    "value": "shipping.province"
  },
  {
    "label": "Shipping Province Code",
    "value": "shipping.provinceCode"
  },
  {
    "label": "Shipping Zip / Postal Code",
    "value": "shipping.zip"
  },
  {
    "label": "Shipping Country",
    "value": "shipping.country"
  },
  {
    "label": "Shipping Country Code",
    "value": "shipping.countryCode"
  },
  {
    "label": "— Customer Fields —",
    "value": "__group_customer",
    "disabled": true
  },
  {
    "label": "Customer Full Name",
    "value": "customer.fullName"
  },
  {
    "label": "Customer First Name",
    "value": "customer.firstName"
  },
  {
    "label": "Customer Last Name",
    "value": "customer.lastName"
  },
  {
    "label": "Customer Email",
    "value": "customer.email"
  },
  {
    "label": "Customer Phone",
    "value": "customer.phone"
  },
  {
    "label": "— Line Item Fields —",
    "value": "__group_lineitem",
    "disabled": true
  },
  {
    "label": "Product Name (Line Item Title)",
    "value": "lineItem.title"
  },
  {
    "label": "Product Code (SKU)",
    "value": "lineItem.sku"
  },
  {
    "label": "Quantity",
    "value": "lineItem.quantity"
  },
  {
    "label": "Price",
    "value": "lineItem.price"
  },
  {
    "label": "— Product / Variant Fields —",
    "value": "__group_product",
    "disabled": true
  },
  {
    "label": "Product Title",
    "value": "product.title"
  },
  {
    "label": "Variant Title",
    "value": "variant.title"
  },
  {
    "label": "Variant Barcode",
    "value": "variant.barcode"
  },
  {
    "label": "— Product Metafields —",
    "value": "__group_metafield_product",
    "disabled": true
  },
  {
    "label": "bayreviews › review_average",
    "value": "metafield.product.bayreviews.review_average"
  },
  {
    "label": "bayreviews › review_count",
    "value": "metafield.product.bayreviews.review_count"
  },
  {
    "label": "custom › ai_part_number",
    "value": "metafield.product.custom.ai_part_number"
  },
  {
    "label": "custom › allowed_to_quotemode",
    "value": "metafield.product.custom.allowed_to_quotemode"
  },
  {
    "label": "custom › alternative_part_numbers",
    "value": "metafield.product.custom.alternative_part_numbers"
  },
  {
    "label": "custom › apn",
    "value": "metafield.product.custom.apn"
  },
  {
    "label": "custom › attributeset",
    "value": "metafield.product.custom.attributeset"
  },
  {
    "label": "custom › belt_bands",
    "value": "metafield.product.custom.belt_bands"
  },
  {
    "label": "custom › belt_inside_measurement",
    "value": "metafield.product.custom.belt_inside_measurement"
  },
  {
    "label": "custom › belt_outside_measurement",
    "value": "metafield.product.custom.belt_outside_measurement"
  },
  {
    "label": "custom › belt_section",
    "value": "metafield.product.custom.belt_section"
  },
  {
    "label": "custom › belt_thickness",
    "value": "metafield.product.custom.belt_thickness"
  },
  {
    "label": "custom › belt_top_width",
    "value": "metafield.product.custom.belt_top_width"
  },
  {
    "label": "custom › bestorq_part_number",
    "value": "metafield.product.custom.bestorq_part_number"
  },
  {
    "label": "custom › brand",
    "value": "metafield.product.custom.brand"
  },
  {
    "label": "custom › can_ship_smartpost",
    "value": "metafield.product.custom.can_ship_smartpost"
  },
  {
    "label": "custom › condition",
    "value": "metafield.product.custom.condition"
  },
  {
    "label": "custom › d_d_part_number",
    "value": "metafield.product.custom.d_d_part_number"
  },
  {
    "label": "custom › distributor_price",
    "value": "metafield.product.custom.distributor_price"
  },
  {
    "label": "custom › end_user_price",
    "value": "metafield.product.custom.end_user_price"
  },
  {
    "label": "custom › featured",
    "value": "metafield.product.custom.featured"
  },
  {
    "label": "custom › featured_home_list",
    "value": "metafield.product.custom.featured_home_list"
  },
  {
    "label": "custom › fitment",
    "value": "metafield.product.custom.fitment"
  },
  {
    "label": "custom › gates_part_number",
    "value": "metafield.product.custom.gates_part_number"
  },
  {
    "label": "custom › group",
    "value": "metafield.product.custom.group"
  },
  {
    "label": "custom › inside_length",
    "value": "metafield.product.custom.inside_length"
  },
  {
    "label": "custom › jason_part_number",
    "value": "metafield.product.custom.jason_part_number"
  },
  {
    "label": "custom › masterdrive_part_number",
    "value": "metafield.product.custom.masterdrive_part_number"
  },
  {
    "label": "custom › meta_keyword",
    "value": "metafield.product.custom.meta_keyword"
  },
  {
    "label": "custom › metal_shipping_rule",
    "value": "metafield.product.custom.metal_shipping_rule"
  },
  {
    "label": "custom › model_information",
    "value": "metafield.product.custom.model_information"
  },
  {
    "label": "custom › number_of_bands",
    "value": "metafield.product.custom.number_of_bands"
  },
  {
    "label": "custom › number_of_grooves",
    "value": "metafield.product.custom.number_of_grooves"
  },
  {
    "label": "custom › number_of_strands",
    "value": "metafield.product.custom.number_of_strands"
  },
  {
    "label": "custom › oem_top_width",
    "value": "metafield.product.custom.oem_top_width"
  },
  {
    "label": "custom › outside_diameter",
    "value": "metafield.product.custom.outside_diameter"
  },
  {
    "label": "custom › part_number",
    "value": "metafield.product.custom.part_number"
  },
  {
    "label": "custom › payment",
    "value": "metafield.product.custom.payment"
  },
  {
    "label": "custom › preferred_vendor",
    "value": "metafield.product.custom.preferred_vendor"
  },
  {
    "label": "custom › product_class",
    "value": "metafield.product.custom.product_class"
  },
  {
    "label": "custom › product_creator",
    "value": "metafield.product.custom.product_creator"
  },
  {
    "label": "custom › product_type",
    "value": "metafield.product.custom.product_type"
  },
  {
    "label": "custom › pulley_type",
    "value": "metafield.product.custom.pulley_type"
  },
  {
    "label": "custom › rcs_style",
    "value": "metafield.product.custom.rcs_style"
  },
  {
    "label": "custom › required_bushing",
    "value": "metafield.product.custom.required_bushing"
  },
  {
    "label": "custom › roller_chain_brand",
    "value": "metafield.product.custom.roller_chain_brand"
  },
  {
    "label": "custom › roller_chain_style",
    "value": "metafield.product.custom.roller_chain_style"
  },
  {
    "label": "custom › searchindex_weight",
    "value": "metafield.product.custom.searchindex_weight"
  },
  {
    "label": "custom › set_of",
    "value": "metafield.product.custom.set_of"
  },
  {
    "label": "custom › topwidth",
    "value": "metafield.product.custom.topwidth"
  },
  {
    "label": "custom › upn",
    "value": "metafield.product.custom.upn"
  },
  {
    "label": "custom › use_simple_product_pricing",
    "value": "metafield.product.custom.use_simple_product_pricing"
  },
  {
    "label": "custom › vbelt_cert",
    "value": "metafield.product.custom.vbelt_cert"
  },
  {
    "label": "custom › vbelt_construction",
    "value": "metafield.product.custom.vbelt_construction"
  },
  {
    "label": "custom › vbelt_depth",
    "value": "metafield.product.custom.vbelt_depth"
  },
  {
    "label": "custom › vbelt_inside_measurement",
    "value": "metafield.product.custom.vbelt_inside_measurement"
  },
  {
    "label": "custom › vbelt_material",
    "value": "metafield.product.custom.vbelt_material"
  },
  {
    "label": "custom › vbelt_outside_meas",
    "value": "metafield.product.custom.vbelt_outside_meas"
  },
  {
    "label": "descriptors › subtitle",
    "value": "metafield.product.descriptors.subtitle"
  },
  {
    "label": "global › description_tag",
    "value": "metafield.product.global.description_tag"
  },
  {
    "label": "global › title_tag",
    "value": "metafield.product.global.title_tag"
  },
  {
    "label": "next_cart › ai_cost",
    "value": "metafield.product.next_cart.ai_cost"
  },
  {
    "label": "next_cart › ai_part_number",
    "value": "metafield.product.next_cart.ai_part_number"
  },
  {
    "label": "next_cart › alternative_part_numbers",
    "value": "metafield.product.next_cart.alternative_part_numbers"
  },
  {
    "label": "next_cart › apn",
    "value": "metafield.product.next_cart.apn"
  },
  {
    "label": "next_cart › automotive_angle",
    "value": "metafield.product.next_cart.automotive_angle"
  },
  {
    "label": "next_cart › automotive_e_length",
    "value": "metafield.product.next_cart.automotive_e_length"
  },
  {
    "label": "next_cart › automotive_outside_length",
    "value": "metafield.product.next_cart.automotive_outside_length"
  },
  {
    "label": "next_cart › automotive_top_width",
    "value": "metafield.product.next_cart.automotive_top_width"
  },
  {
    "label": "next_cart › belt_bands",
    "value": "metafield.product.next_cart.belt_bands"
  },
  {
    "label": "next_cart › belt_inside_measurement",
    "value": "metafield.product.next_cart.belt_inside_measurement"
  },
  {
    "label": "next_cart › belt_outside_measurement",
    "value": "metafield.product.next_cart.belt_outside_measurement"
  },
  {
    "label": "next_cart › belt_section",
    "value": "metafield.product.next_cart.belt_section"
  },
  {
    "label": "next_cart › belt_thickness",
    "value": "metafield.product.next_cart.belt_thickness"
  },
  {
    "label": "next_cart › belt_top_width",
    "value": "metafield.product.next_cart.belt_top_width"
  },
  {
    "label": "next_cart › bestorq_part_number",
    "value": "metafield.product.next_cart.bestorq_part_number"
  },
  {
    "label": "next_cart › bore_size",
    "value": "metafield.product.next_cart.bore_size"
  },
  {
    "label": "next_cart › brand",
    "value": "metafield.product.next_cart.brand"
  },
  {
    "label": "next_cart › btq_cost",
    "value": "metafield.product.next_cart.btq_cost"
  },
  {
    "label": "next_cart › can_ship_smartpost",
    "value": "metafield.product.next_cart.can_ship_smartpost"
  },
  {
    "label": "next_cart › condition",
    "value": "metafield.product.next_cart.condition"
  },
  {
    "label": "next_cart › cost",
    "value": "metafield.product.next_cart.cost"
  },
  {
    "label": "next_cart › d_d_part_number",
    "value": "metafield.product.next_cart.d_d_part_number"
  },
  {
    "label": "next_cart › dd_cost",
    "value": "metafield.product.next_cart.dd_cost"
  },
  {
    "label": "next_cart › diameter",
    "value": "metafield.product.next_cart.diameter"
  },
  {
    "label": "next_cart › distributor_price",
    "value": "metafield.product.next_cart.distributor_price"
  },
  {
    "label": "next_cart › effective_length_aa",
    "value": "metafield.product.next_cart.effective_length_aa"
  },
  {
    "label": "next_cart › end_user_price",
    "value": "metafield.product.next_cart.end_user_price"
  },
  {
    "label": "next_cart › featured",
    "value": "metafield.product.next_cart.featured"
  },
  {
    "label": "next_cart › featured_home_list",
    "value": "metafield.product.next_cart.featured_home_list"
  },
  {
    "label": "next_cart › fitment",
    "value": "metafield.product.next_cart.fitment"
  },
  {
    "label": "next_cart › free_shipping",
    "value": "metafield.product.next_cart.free_shipping"
  },
  {
    "label": "next_cart › gates_cost",
    "value": "metafield.product.next_cart.gates_cost"
  },
  {
    "label": "next_cart › gates_part_number",
    "value": "metafield.product.next_cart.gates_part_number"
  },
  {
    "label": "next_cart › group",
    "value": "metafield.product.next_cart.group"
  },
  {
    "label": "next_cart › inside_length",
    "value": "metafield.product.next_cart.inside_length"
  },
  {
    "label": "next_cart › jason_cost",
    "value": "metafield.product.next_cart.jason_cost"
  },
  {
    "label": "next_cart › jason_part_number",
    "value": "metafield.product.next_cart.jason_part_number"
  },
  {
    "label": "next_cart › keyway",
    "value": "metafield.product.next_cart.keyway"
  },
  {
    "label": "next_cart › length",
    "value": "metafield.product.next_cart.length"
  },
  {
    "label": "next_cart › masterdrive_part_number",
    "value": "metafield.product.next_cart.masterdrive_part_number"
  },
  {
    "label": "next_cart › mbl_cost",
    "value": "metafield.product.next_cart.mbl_cost"
  },
  {
    "label": "next_cart › mbl_part_number",
    "value": "metafield.product.next_cart.mbl_part_number"
  },
  {
    "label": "next_cart › md_cost",
    "value": "metafield.product.next_cart.md_cost"
  },
  {
    "label": "next_cart › model_information",
    "value": "metafield.product.next_cart.model_information"
  },
  {
    "label": "next_cart › number_of_bands",
    "value": "metafield.product.next_cart.number_of_bands"
  },
  {
    "label": "next_cart › number_of_teeth",
    "value": "metafield.product.next_cart.number_of_teeth"
  },
  {
    "label": "next_cart › oem_top_width",
    "value": "metafield.product.next_cart.oem_top_width"
  },
  {
    "label": "next_cart › outside_diameter",
    "value": "metafield.product.next_cart.outside_diameter"
  },
  {
    "label": "next_cart › part_number",
    "value": "metafield.product.next_cart.part_number"
  },
  {
    "label": "next_cart › payment",
    "value": "metafield.product.next_cart.payment"
  },
  {
    "label": "next_cart › preferred_vendor",
    "value": "metafield.product.next_cart.preferred_vendor"
  },
  {
    "label": "next_cart › product_class",
    "value": "metafield.product.next_cart.product_class"
  },
  {
    "label": "next_cart › product_creator",
    "value": "metafield.product.next_cart.product_creator"
  },
  {
    "label": "next_cart › related_products",
    "value": "metafield.product.next_cart.related_products"
  },
  {
    "label": "next_cart › searchindex_weight",
    "value": "metafield.product.next_cart.searchindex_weight"
  },
  {
    "label": "next_cart › set_of",
    "value": "metafield.product.next_cart.set_of"
  },
  {
    "label": "next_cart › short_description",
    "value": "metafield.product.next_cart.short_description"
  },
  {
    "label": "next_cart › timing_belt_length",
    "value": "metafield.product.next_cart.timing_belt_length"
  },
  {
    "label": "next_cart › timing_belt_width",
    "value": "metafield.product.next_cart.timing_belt_width"
  },
  {
    "label": "next_cart › top_width_banded",
    "value": "metafield.product.next_cart.top_width_banded"
  },
  {
    "label": "next_cart › upn",
    "value": "metafield.product.next_cart.upn"
  },
  {
    "label": "next_cart › use_simple_product_pricing",
    "value": "metafield.product.next_cart.use_simple_product_pricing"
  },
  {
    "label": "next_cart › vbelt_cert",
    "value": "metafield.product.next_cart.vbelt_cert"
  },
  {
    "label": "next_cart › vbelt_construction",
    "value": "metafield.product.next_cart.vbelt_construction"
  },
  {
    "label": "next_cart › vbelt_cord_type",
    "value": "metafield.product.next_cart.vbelt_cord_type"
  },
  {
    "label": "next_cart › vbelt_depth",
    "value": "metafield.product.next_cart.vbelt_depth"
  },
  {
    "label": "next_cart › vbelt_inside_measurement",
    "value": "metafield.product.next_cart.vbelt_inside_measurement"
  },
  {
    "label": "next_cart › vbelt_material",
    "value": "metafield.product.next_cart.vbelt_material"
  },
  {
    "label": "next_cart › vbelt_outside_meas",
    "value": "metafield.product.next_cart.vbelt_outside_meas"
  },
  {
    "label": "next_cart › vbs_classic_inside_measure",
    "value": "metafield.product.next_cart.vbs_classic_inside_measure"
  },
  {
    "label": "next_cart › vbs_classic_outside_measure",
    "value": "metafield.product.next_cart.vbs_classic_outside_measure"
  },
  {
    "label": "next_cart › vbs_classic_top_width",
    "value": "metafield.product.next_cart.vbs_classic_top_width"
  },
  {
    "label": "next_cart › width",
    "value": "metafield.product.next_cart.width"
  },
  {
    "label": "shopify--discovery--product_recommendation › related_products",
    "value": "metafield.product.shopify--discovery--product_recommendation.related_products"
  },
  {
    "label": "shopify--discovery--product_recommendation › related_products_display",
    "value": "metafield.product.shopify--discovery--product_recommendation.related_products_display"
  },
  {
    "label": "— Collection Metafields —",
    "value": "__group_metafield_collection",
    "disabled": true
  },
  {
    "label": "custom › category_image",
    "value": "metafield.collection.custom.category_image"
  },
  {
    "label": "custom › category_name",
    "value": "metafield.collection.custom.category_name"
  },
  {
    "label": "global › meta_keywords",
    "value": "metafield.collection.global.meta_keywords"
  },
  {
    "label": "— Customer Metafields —",
    "value": "__group_metafield_customer",
    "disabled": true
  },
  {
    "label": "avada_joy › point",
    "value": "metafield.customer.avada_joy.point"
  },
  {
    "label": "checkoutblocks › trigger",
    "value": "metafield.customer.checkoutblocks.trigger"
  },
  {
    "label": "custom › allow_remote_shopping_assistance",
    "value": "metafield.customer.custom.allow_remote_shopping_assistance"
  },
  {
    "label": "custom › authnetcim_profile_version",
    "value": "metafield.customer.custom.authnetcim_profile_version"
  },
  {
    "label": "custom › industry",
    "value": "metafield.customer.custom.industry"
  },
  {
    "label": "custom › name_suffix",
    "value": "metafield.customer.custom.name_suffix"
  },
  {
    "label": "custom › open_amount_min",
    "value": "metafield.customer.custom.open_amount_min"
  },
  {
    "label": "custom › reward_update_notification",
    "value": "metafield.customer.custom.reward_update_notification"
  },
  {
    "label": "custom › reward_warning_notification",
    "value": "metafield.customer.custom.reward_warning_notification"
  },
  {
    "label": "— Order Metafields —",
    "value": "__group_metafield_order",
    "disabled": true
  },
  {
    "label": "checkoutblocks › customer_industries",
    "value": "metafield.order.checkoutblocks.customer_industries"
  },
  {
    "label": "checkoutblocks › special_instructions",
    "value": "metafield.order.checkoutblocks.special_instructions"
  },
  {
    "label": "checkoutblocks › views",
    "value": "metafield.order.checkoutblocks.views"
  },
  {
    "label": "custom › account_manager",
    "value": "metafield.order.custom.account_manager"
  },
  {
    "label": "custom › customer_industries",
    "value": "metafield.order.custom.customer_industries"
  },
  {
    "label": "custom › customer_suffix",
    "value": "metafield.order.custom.customer_suffix"
  },
  {
    "label": "custom › freight_account_number",
    "value": "metafield.order.custom.freight_account_number"
  },
  {
    "label": "custom › how_did_you_find_your_belt",
    "value": "metafield.order.custom.how_did_you_find_your_belt"
  },
  {
    "label": "custom › how_did_you_hear",
    "value": "metafield.order.custom.how_did_you_hear"
  },
  {
    "label": "custom › if_other_tell_us_how",
    "value": "metafield.order.custom.if_other_tell_us_how"
  },
  {
    "label": "custom › invoice_id",
    "value": "metafield.order.custom.invoice_id"
  },
  {
    "label": "custom › machine_oem_info",
    "value": "metafield.order.custom.machine_oem_info"
  },
  {
    "label": "custom › purchase_order_number",
    "value": "metafield.order.custom.purchase_order_number"
  },
  {
    "label": "custom › purchased_from",
    "value": "metafield.order.custom.purchased_from"
  },
  {
    "label": "custom › shipment_id",
    "value": "metafield.order.custom.shipment_id"
  },
  {
    "label": "custom › shipping_account_number",
    "value": "metafield.order.custom.shipping_account_number"
  },
  {
    "label": "custom › shipping_and_handling",
    "value": "metafield.order.custom.shipping_and_handling"
  },
  {
    "label": "custom › special_instructions",
    "value": "metafield.order.custom.special_instructions"
  },
  {
    "label": "— Company Metafields —",
    "value": "__group_metafield_company",
    "disabled": true
  },
  {
    "label": "checkoutblocks › trigger",
    "value": "metafield.company.checkoutblocks.trigger"
  },
  {
    "label": "— Shop Metafields —",
    "value": "__group_metafield_shop",
    "disabled": true
  },
  {
    "label": "OmegaQuoteB2BSettings › omg-quote-snap-b2b-setting",
    "value": "metafield.shop.OmegaQuoteB2BSettings.omg-quote-snap-b2b-setting"
  },
  {
    "label": "OmegaQuoteDTCSettings › omg-quote-snap-dtc-setting",
    "value": "metafield.shop.OmegaQuoteDTCSettings.omg-quote-snap-dtc-setting"
  },
  {
    "label": "OmegaQuoteSettings › omg-quote-list-settings",
    "value": "metafield.shop.OmegaQuoteSettings.omg-quote-list-settings"
  },
  {
    "label": "checkoutblocks › blocks_list_checkout_custom_field",
    "value": "metafield.shop.checkoutblocks.blocks_list_checkout_custom_field"
  },
  {
    "label": "checkoutblocks › config",
    "value": "metafield.shop.checkoutblocks.config"
  },
  {
    "label": "checkoutblocks › currencies",
    "value": "metafield.shop.checkoutblocks.currencies"
  },
  {
    "label": "joy_loyalty › data",
    "value": "metafield.shop.joy_loyalty.data"
  },
  {
    "label": "joy_loyalty › data_function",
    "value": "metafield.shop.joy_loyalty.data_function"
  },
  {
    "label": "joy_loyalty_avada › data",
    "value": "metafield.shop.joy_loyalty_avada.data"
  },
  {
    "label": "joy_loyalty_avada › loyalty_data",
    "value": "metafield.shop.joy_loyalty_avada.loyalty_data"
  },
  {
    "label": "joy_loyalty_extension › data",
    "value": "metafield.shop.joy_loyalty_extension.data"
  },
  {
    "label": "mworx_apo › config",
    "value": "metafield.shop.mworx_apo.config"
  },
  {
    "label": "mworx_apo › cta_config",
    "value": "metafield.shop.mworx_apo.cta_config"
  },
  {
    "label": "omg_discount_usages › limit_usage",
    "value": "metafield.shop.omg_discount_usages.limit_usage"
  },
  {
    "label": "— Static / Empty —",
    "value": "__group_static",
    "disabled": true
  },
  {
    "label": "Static / Empty Value",
    "value": "static"
  }
];
